import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getVolunteerrequest,
  editVolunteerrequest,
} from "../../store/actions/volunteerrequests_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import {
  initialValues,
  inputFields,
} from "../../shared/enums/volunteerrequests_enum";

const EditVolunteerrequest = ({
  editVolunteerrequest,
  getVolunteerrequest,
  match,
  volunteerrequest: { loading, volunteerrequest },
}) => {
  let history = useHistory();
  useEffect(() => {
    getVolunteerrequest(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitVolunteerrequest = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editVolunteerrequest(volunteerrequest.id, values);
    history.push(`/volunteerrequests/${volunteerrequest.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Volunteerrequest"
          mainLinkTitle="Volunteerrequests"
          mainLinkUrl="/volunteerrequests"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              volunteerrequest && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {volunteerrequest[Object.keys(inputFields)[0]]} -{" "}
                        <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link
                          to="/volunteerrequests"
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-angle-left"></i> Volunteerrequests
                        </Link>
                        <Link
                          to={`/volunteerrequests/${volunteerrequest.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={volunteerrequest}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitVolunteerrequest}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  volunteerrequest: state.volunteerrequest,
});

const mapDispatchToProps = { editVolunteerrequest, getVolunteerrequest };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditVolunteerrequest);
